import { ThisConnector } from '../../../../api/connector'
import { BaseApiResponse } from '../../../../api/shared'

export interface AiUpdateSettingsArgs {
  organizationId: string
  intelligentRemediationGuidanceEnabled: boolean
  intelligentRemediationGuidanceDisclaimerEnabled: boolean
}

export async function updateAiSettings(
  this: ThisConnector,
  {
    organizationId,
    intelligentRemediationGuidanceEnabled,
    intelligentRemediationGuidanceDisclaimerEnabled
  }: AiUpdateSettingsArgs
): Promise<BaseApiResponse> {
  const { messages, success } = await this.connector.put<BaseApiResponse>(
    `/${organizationId}/settings/aiml`,
    {
      intelligent_remediation_guidance_enabled:
        intelligentRemediationGuidanceEnabled,
      intelligent_remediation_guidance_disclaimer_enabled:
        intelligentRemediationGuidanceDisclaimerEnabled
    }
  )

  return {
    success,
    messages
  }
}
